import { words } from './globalState';
import { signWithKey } from './keysAndSigning';
import {
  handleClickItemOrderHistory,
} from './monadomCore';
import {
  devLog,
  localTime,
  syncHttpRequest2,
} from 'utils';

// 「商品検索」ボタン押下 HANDLE CLICK GET REGISTERED ITEM
async function handleClickGetRegisteredItem(state, dispatch, pagingIndex, directAccessParameters) {
  let request = {};
  let messages = {};

  // state固定
  const stateFixed = {
    action: state.getRegisteredItem.action,
    addressMain: state.active.addressMain,
    sessionId: state.session[state.active.addressMain]?.sessionId,
    lastEvaluatedKey: pagingIndex >= 1 ? state.getRegisteredItem.lastEvaluatedKey[state.getRegisteredItem.action][pagingIndex - 1] : null,
  };

  // if (directAccessParameters !== undefined) {
  //   stateFixed.action = 'duelHistorySingle';
  //   stateFixed.roomId = directAccessParameters.roomId;
  //   stateFixed.duelNo = directAccessParameters.duelNo;
  // }

  devLog('from', `${stateFixed.yearFrom}/${stateFixed.monthFrom}/${stateFixed.dayFrom}`);
  devLog('from epoch', localTime(stateFixed.epochFrom));
  devLog('to', `${stateFixed.yearTo}/${stateFixed.monthTo}/${stateFixed.dayTo}`);
  devLog('to epoch', localTime(stateFixed.epochTo));

  // 入力値チェック
  // -- なし。


  request.body = JSON.stringify({
    body: {
      action: stateFixed.action,
      addressMain: stateFixed.addressMain,
      sessionId: stateFixed.sessionId,
      lastEvaluatedKey: stateFixed.lastEvaluatedKey,
    },
  });

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/get_history_open';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, stateFixed.action, undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    if (response.body.lastEvaluatedKey !== undefined) {
      dispatch({ type: 'setStateMultiLayers', keys: ['getRegisteredItem', 'lastEvaluatedKey', stateFixed.action, pagingIndex], value: response.body.lastEvaluatedKey });
    }
    else {
      dispatch({ type: 'setStateMultiLayers', keys: ['getRegisteredItem', 'lastEvaluatedKey', stateFixed.action, pagingIndex], value: null });
    }

    dispatch({ type: 'setStateMultiLayers', keys: ['getRegisteredItem', 'pagingIndex', stateFixed.action], value: pagingIndex });

    // // cookie情報更新(アドレス情報)
    // const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
    // const cookiesNew = [
    //       {
    //         action: 'searchPurchaseHistory',
    //         addressType: 'addressMain',
    //         description: `${userName}`,
    //         time: now,
    //         address: stateFixed.addressMain
    //       },
    // ];

    // setAddressesInCookie(state, dispatch, cookies, setCookie, stateFixed.addressMain, cookiesNew);

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

// ADD TO CART
function addToCart(state, dispatch, item) {
  const thisItemInCart = state.checkout.itemsIncart[item.itemNo];

  if (thisItemInCart?.amountToBuy >= item.stock) {
    return {
      status: 'rejected',
    };
  }
  else if (thisItemInCart !== undefined) {
    const thisItemInCartAmount = thisItemInCart.amountToBuy;
    dispatch({ type: 'setStateMultiLayers', keys: ['checkout', 'itemsIncart', item.itemNo, 'amountToBuy'], value: thisItemInCartAmount + 1 });

    return {
      status: 'fulfilled',
      body: thisItemInCartAmount + 1,
    };
  }
  else {
    const itemNew = {
      itemNo: item.itemNo,
      amountToBuy: 1,
      information: item,
    };

    dispatch({ type: 'setStateMultiLayers', keys: ['checkout', 'itemsIncart', item.itemNo], value: itemNew });

    return {
      status: 'fulfilled',
      body: 1,
    };
  }
}

// REMOVE FROM CART
function removeFromCart(state, dispatch, item) {
  const thisItemInCart = state.checkout.itemsIncart[item.itemNo];

  if (thisItemInCart === undefined || thisItemInCart.amountToBuy === 0) {
    return {
      status: 'rejected',
    };
  }
  else {
    const thisItemInCartAmount = thisItemInCart.amountToBuy;
    dispatch({ type: 'setStateMultiLayers', keys: ['checkout', 'itemsIncart', item.itemNo, 'amountToBuy'], value: thisItemInCartAmount - 1 });

    return {
      status: 'fulfilled',
      body: thisItemInCartAmount - 1,
    };
  }
}

// 「商品購入:署名」ボタン押下 HANDLE CLICK SUBMIT ORDER
// ずばり署名する鍵を渡す。
async function handleClickSubmitOrder(state, dispatch, navigate, keyPair) {
  let addressActual;
  let signature;
  let request = {};
  let messages = {};
  let bodyObj = {};
  const itemsIncartNotZero =[];

  // state固定
  const stateFixed = {
    addressMain: state.checkout.addressMain,
    mailAddress: state.checkout.mailAddress,
    paymentMethod: state.checkout.paymentMethod,
    itemsIncart: Object.values(state.checkout.itemsIncart),
    signatureVersion: state.config.clientParameters.signatureVersion.purchaseItem,
    // addressCheck: state.addressCheck,
    addressCheck: 'strict',
    minimumPurchaseAmount: state.config.clientParameters.itemSales.minimumPurchaseAmount,
  };

  // if (keyPairs !== undefined && keyPairs !== null) {
  //   keyPair = keyPairs[0];
  //   const result = getAddressFromKey(state, dispatch, keyPair);

  //   if (result.status === 'fulfilled') {
  //     stateFixed.addressMain = result.address;
  //   }
  //   else {
  //     dispatch({ type: 'setNotification', key: 'notification', value: words.failedToGetTheAddress[state.language] });
  //     return result;
  //   }
  // }

  const priceJpyTotal = stateFixed.itemsIncart.reduce( (acc, cur) => acc + cur.information.priceJpy * cur.amountToBuy, 0);

  // 必須項目チェック
  if (stateFixed.addressMain === undefined || stateFixed.addressMain === null || stateFixed.addressMain === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.pleaseLogin[state.language] });
    return { status: 'rejected' };
  }

  if (stateFixed.mailAddress === undefined || stateFixed.mailAddress === null || stateFixed.mailAddress === '') {
    dispatch({ type: 'setNotification', key: 'notification', value: words.mailAddressMustBeFilled[state.language] });
    return { status: 'rejected' };
  }

  if (stateFixed.paymentMethod === undefined || stateFixed.paymentMethod === null || stateFixed.paymentMethod === '') {
    // dispatch({ type: 'setNotification', key: 'notification', value: words.mailAddressMustBeFilled[state.language] });
    return { status: 'rejected' };
  }

  // 購入量が0の商品は削除する。 
  for (const item of stateFixed.itemsIncart) {
    if (item.amountToBuy >= 1) {
      itemsIncartNotZero.push(item);
    }
  }

  // カートに商品があるかチェック
  // if (Object.values(stateFixed.itemsIncart).filter( item => item.amountToBuy >= 1 ).length < 1) {}
  if (itemsIncartNotZero.length < 1) {
    dispatch({ type: 'setNotification', key: 'notification', value: words.addItemsToYourCart[state.language] });
    return { status: 'rejected' };
  }

  // 購入金額が最低金額以上になっているかチェック
  if (priceJpyTotal < stateFixed.minimumPurchaseAmount) {
    dispatch({ type: 'setNotification', key: 'notification',
      value: words.thePurchaseAmountMustBeMoreThanOrEqualTo1[state.language] + stateFixed.minimumPurchaseAmount + words.thePurchaseAmountMustBeMoreThanOrEqualTo2[state.language]
    });
    return { status: 'rejected' };
  }


  const clientTime = Date.now();
  const message = `I will buy items for ${priceJpyTotal} JPY. I will buy them as ${stateFixed.addressMain}. (epoch time: ${clientTime}, signature version: ${stateFixed.signatureVersion})`;

  if (keyPair !== undefined) {
    addressActual = stateFixed.addressMain;

    const result = signWithKey(state, dispatch, keyPair, message, state.networkMona);

    if (result.status === 'fulfilled') {
      signature = result.signature;
    }
    else {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return 'rejected';
    }
  }
  else {
    // Mpurseのアドレスが合ってるかチェック
    const result = await window.mpurse.getAddress()
    .then( (result) => {
      addressActual = result;

      if (stateFixed.addressCheck === 'strict') {
        if (addressActual !== stateFixed.addressMain) {
          dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressLoggedInAndTheAddressInWalletAreDifferent[state.language] });
          return 'rejected';
        }
        else {
          return 'fulfilled';
        }
      }
      else { // off
        return 'fulfilled';
      }
    })
    .catch( (error) => {
        dispatch({ type: 'setNotification', key: 'notification', value: words.theAddressInYourWalletCanNotBeGotten[state.language] });
        return 'rejected';
    });

    if (result === 'rejected') {
      return { status: 'rejected' };
    }

    // 署名

    try {
      signature= await window.mpurse.signMessage(message).then( result => result );
    }
    catch (err) {
      dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSign[state.language] });
      return { status: 'rejected' };
    }
  }

  // GO！

  bodyObj = {
    body: {
      addressMain: stateFixed.addressMain,
      addressMainActual: addressActual,
      mailAddress: stateFixed.mailAddress,
      paymentMethod: stateFixed.paymentMethod,
      items: itemsIncartNotZero,
      clientTimeOfAddressMain: clientTime,
      signatureByAddressMain: signature,
      signatureVersionOfAddressMain: stateFixed.signatureVersion,
    }
  };

  request.body = JSON.stringify(bodyObj);
  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/purchase_item';
  request.method = 'POST';

  messages = {
    "you must accept the terms and conditions of the current version.": words.youMustAcceptTheTermsAndConditionsOfTheCurrentVersion[state.language],
    "internal server error": words.internalServerError[state.language],
    "bad signature": words.badSignature[state.language],
    "unknown signatureVersion": words.unknownSignatureVersion[state.language],
    "clientTime must be larger than last time.": words.clientTimeMustBeLargerThanLastTime[state.language],
    "this address is not permitted.": words.thisAddressIsNotPermitted[state.language],
    "this address is forbidden.": words.thisAddressIsForbidden[state.language],
    "out of service": words.outOfService[state.language],
    "user does not exist.": words.pleaseRegisterAsAUserOnTheSetupPage[state.language],
    "success": words.thankYouForYourPurchase[state.language],
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, undefined, undefined, 'notification', messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {
    // const purchaseItem = response.body.purchaseItem;
    const sessionId = response.body.sessionId;
    const expirationOfSession = response.body.expirationOfSession;
    const paygentLink = response.body.paygentLink;

    // checkout情報更新
    // dispatch({ type: 'setState', key: 'checkout', value: purchaseItem });
    // カートの中は空にする！！
    dispatch({ type: 'setStateMultiLayers', keys: ['checkout', 'itemsIncart'], value: {} });

    // session情報更新
    dispatch({ type: 'setStateMultiLayers', keys: ['session', stateFixed.addressMain], value: {'sessionId': sessionId[stateFixed.addressMain], 'expirationOfSession': expirationOfSession[stateFixed.addressMain]} });

    // if (addressActual !== stateFixed.addressMain) {
    //   dispatch({ type: 'setStateMultiLayers', keys: ['session', addressActual], value: {'sessionId': sessionId.addressMainActual, 'expirationOfSession': expirationOfSession.addressMainActual} });
    // }

    // // オーダーNo.通知欄表示(全署名完了していたら)
    // if ( purchasePoint.signatureByAddressMain !== undefined && purchasePoint.signatureByAddressMain !== null && purchasePoint.signatureByAddressMain !== '' &&
    //      purchasePoint.signatureByAddressPayFrom !== undefined && purchasePoint.signatureByAddressPayFrom !== null && purchasePoint.signatureByAddressPayFrom !== '') {
    //   dispatch({ type: 'setNotification', key: 'notification', value: words.acceptedAsPurchaseNoX1[state.language] + purchasePoint.purchaseNo + words.acceptedAsPurchaseNoX2[state.language] });
    // }

    if (stateFixed.paymentMethod === 'paygent') {
      const paygent = window.open(paygentLink);
      paygent.focus();
    }

    // 商品購入履歴画面に飛ばしたあと自動検索が走るように、メインアドレスを設定して、履歴を消す！
    dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'addressMain'], value: stateFixed.addressMain });
    dispatch({ type: 'setStateMultiLayers', keys: ['itemOrderHistory', stateFixed.addressMain], value: undefined });

    const activeCertification = {
      address: stateFixed.addressMain,
      sessionId: sessionId[stateFixed.addressMain],
      expirationOfSession: expirationOfSession[stateFixed.addressMain],
    };

    // 商品購入履歴画面に飛ばす。
    handleClickItemOrderHistory(state, dispatch, navigate, { activeCertification: activeCertification });
  }
  else {
    return { status: 'rejected' };
  }

  return response;
}

// 「商品注文履歴:検索」ボタン押下 HANDLE CLICK GET ITEM ORDER HISTORY
// ログイン前提とし、セッションのみに対応する。
async function handleClickGetItemOrderHistory(state, dispatch, pagingIndex, activeCertification, consistentRead, keyPairs) {
  let request = {};
  let messages = {};
  let certifications = [];
  const now = Date.now();

  if (activeCertification === undefined || activeCertification === null) {
    activeCertification = {
      address: null,
    };
  }

  if (consistentRead === undefined || consistentRead === null) {
    consistentRead = false;
  }

  // state固定
  const stateFixed = {
    addressMain: state.getItemOrderHistory.addressMain,
    lastEvaluatedKey: pagingIndex >= 1 ? state.getItemOrderHistory.lastEvaluatedKey.itemOrder[pagingIndex - 1] : null,
    signatureVersion: state.config.clientParameters.signatureVersion.getItemOrderHistory,
    walletType: state.walletType,
    addressCheck: 'strict',
  };

  // 有効なセッションに絞り込む。

  for (const address of Object.keys(state.session)) {

    // activeCertificationの場合は別処理
    if (address !== activeCertification.address) {

      // state固定
      stateFixed[address] = {
        // addressCoinType: state.session[address].addressCoinType,
        sessionId: state.session[address].sessionId,
        expirationOfSession: state.session[address].expirationOfSession,
      };

      if (stateFixed[address].expirationOfSession >= now + state.marginOfSessionTime) {
        certifications.push({
          // addressCoinType: stateFixed[address].addressCoinType,
          address: address,
          sessionId: stateFixed[address].sessionId,
          lastEvaluatedKey: address === stateFixed.addressMain ? stateFixed.lastEvaluatedKey : null,
          consistentRead: address === stateFixed.addressMain ? consistentRead : false,
        });
      }
    }
  }

  // activeCertificationの処理

  if (activeCertification.address !== null) {
    // -- state固定
    stateFixed[activeCertification.address] = {
      sessionId: activeCertification.sessionId,
      expirationOfSession: activeCertification.expirationOfSession,
    };

    // -- 有効だったら(まあほぼ有効なんだろうけど)プッシュ
    if (stateFixed[activeCertification.address].expirationOfSession >= now + state.marginOfSessionTime) {
      certifications.push({
        address: activeCertification.address,
        sessionId: stateFixed[activeCertification.address].sessionId,
        lastEvaluatedKey: null, // activeCertificationは常に先頭を検索する。
        consistentRead: true, // activeCertificationは常に強力な整合性のある読み込みをする。
      });
    }
  }

  // const keyPairsInPool = getValidKeyPairs(state, dispatch);

  // const extendedCertificationProperties = [
  //   { key: 'consistentRead', value: consistentRead },
  // ];

  // if (
  //   stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
  //   keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined
  // ) {
  //   certificationWithKey(state, dispatch, [ keyPairsInPool[stateFixed.addressMain].keyPair ], 'information', stateFixed, certifications, now, extendedCertificationProperties, 'matchedKey');
  // }
  // else if (keyPairs !== undefined && keyPairs !== null) {
  //   certificationWithKey(state, dispatch, keyPairs, 'information', stateFixed, certifications, now, extendedCertificationProperties, 'firstKey');
  // }
  // else if (stateFixed.walletType === 'mpurse') {
  //   await setSignatureByAddressMain(state, dispatch, stateFixed, certifications, now, extendedCertificationProperties, 'information');
  // }

  // addressMainは必須。事前ログイン前提なので、ここで鍵は求めない。

  if (
    // certifications.length === 0 ||
    // stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    // if (keyPairs === undefined || keyPairs === null) {
    //   if (stateFixed.walletType === 'nfc') {
    //     dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[state.language] });
    //     return {
    //       status: 'rejected',
    //       message: 'nfcRequired',
    //     };
    //   }
    //   else if (stateFixed.walletType === 'qr') {
    //     dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[state.language] });
    //     return {
    //       status: 'rejected',
    //       message: 'bcRequired',
    //     };
    //   }
    // }

    // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }

  request.body = JSON.stringify({
    body: {
      action: 'itemOrder',
      certifications: certifications,
    },
  });

  request.url = 'https://' + process.env.REACT_APP_KOM_API_DOMAIN + '/get_history';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'itemOrderHistory', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  if ( response.status === 'fulfilled' ) {

    for (const address of Object.keys(response.body)) {
      // 署名した場合もろもろ更新
      if (response.body[address]['certificatedBy'] === 'signature') {

        // session更新
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
          value: {'sessionId': response.body[address]['sessionId'], 'expirationOfSession': response.body[address]['expirationOfSession']} });
      }
      else if (response.body[address]['certificatedBy'] === 'none') {
        dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
      }
    }

    // addressMainが検索対象で、検索成功した場合
    if (response.body[stateFixed.addressMain]?.certificatedBy === 'signature' || response.body[stateFixed.addressMain]?.certificatedBy === 'sessionId') {
      if (response.body[stateFixed.addressMain].lastEvaluatedKey !== undefined) {
        dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'lastEvaluatedKey', 'itemOrder', pagingIndex], value: response.body[stateFixed.addressMain].lastEvaluatedKey });
      }
      else {
        dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'lastEvaluatedKey', 'itemOrder', pagingIndex], value: null });
      }

      dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'pagingIndex', 'itemOrder'], value: pagingIndex });

      // addressMainが指定されていなかった場合は、dispatchする。
      if (state.getItemOrderHistory.addressMain === undefined || state.getItemOrderHistory.addressMain === null || state.getItemOrderHistory.addressMain === '') {
        dispatch({ type: 'setStateMultiLayers', keys: ['getItemOrderHistory', 'addressMain'], value: stateFixed.addressMain });
      }

      // // cookie情報更新(アドレス情報)
      // const userName = state.usersGeneralIndex[stateFixed.addressMain] !== undefined ? state.usersGeneralIndex[stateFixed.addressMain].userName : stateFixed.addressMain;
      // const cookiesNew = [
      //       {
      //         action: 'searchPurchaseHistory',
      //         addressType: 'addressMain',
      //         description: `${userName}`,
      //         time: now,
      //         address: stateFixed.addressMain
      //       },
      // ];

      // setAddressesInCookie(state, dispatch, cookies, setCookie, stateFixed.addressMain, cookiesNew);
    }

    return { status: 'fulfilled', body: response.body };
  }
  else {
    dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSearch[state.language] });
    return { status: 'rejected' };
  }
}

export {
  handleClickGetRegisteredItem,
  addToCart,
  removeFromCart,
  handleClickSubmitOrder,
  handleClickGetItemOrderHistory,
}